import { axiosInstance as axios } from "./axiosInstance";
const API_URL = process.env.REACT_APP_URL;

const getColdCallingLeads = (payload) => {
  const token = localStorage.getItem("_ux98c_v1");

  return axios.get(`${API_URL}/lead/cold-calling-leads`, {
    params: payload,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

const coldcallinguploadLeadExcel =
    (body) => {
        const token = localStorage.getItem("_ux98c_v1");
        return axios.post(
            `${API_URL}/lead/cold-calling-upload-excel`,
            body,
            {
                headers: {
                    Authorization:
                        `Bearer ${token}`,
                },
            }
        );

    };

    const addcoldcallingLead = (data) => {
        const token = localStorage.getItem("_ux98c_v1");
    
        return axios.post(
            `${API_URL}/lead/addcoldcalling-lead`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
    
    };

    const coldcallingExportExcel = (
        payload,
        
    ) => {
        const token = localStorage.getItem("_ux98c_v1");
        
        return axios.get(
            `${API_URL}/lead/exportLeadForColdCalling`,
            {
                params: payload,
    
                responseType: "blob",
    
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
    
    };

export{
    getColdCallingLeads,
    coldcallinguploadLeadExcel,
    addcoldcallingLead,
    coldcallingExportExcel
}